import type { FC } from 'react'

import { Table } from '@skytech/ui'

import type { DemoCustomers } from '@/api/demoCustomersApi'
import { Translation } from '@/components/i18n/Translation'
import { ResultCount } from '@/components/ResultCount'
import NoResults from '@/components/util/NoResults'
import useRenderLimit from '@/hooks/render-limit-hook'

import { DemoCustomerListItem } from './DemoCustomerListItem'

export const DemoCustomerList: FC<{
  demoCustomers: DemoCustomers[]
  searchFilter: string
}> = ({ demoCustomers, searchFilter }) => {
  const { visibleList, ListLoaderComponent } = useRenderLimit(demoCustomers || [])

  return (
    <>
      <ResultCount count={visibleList.length} />
      <Table rowHeight="tall">
        <thead>
          <tr>
            <th className="p-4 normal-case">
              <Translation id="Local" />
            </th>
            <th className="p-4 normal-case">
              <Translation id="Global" />
            </th>
            <th className="center hidden p-4 normal-case sm:table-cell">
              <Translation id="Country" />
            </th>
            <th className="center hidden p-4 normal-case sm:table-cell">
              <Translation id="Number of users" />
            </th>
            <th className="center hidden p-4 normal-case sm:table-cell">
              <Translation id="Number of employees" />
            </th>
          </tr>
        </thead>

        <tbody>
          {visibleList.map(item => (
            <DemoCustomerListItem key={item.id} searchFilter={searchFilter} {...item} />
          ))}
        </tbody>
      </Table>

      {visibleList.length === 0 && (
        <div className="my-4">
          <NoResults />
        </div>
      )}
      <ListLoaderComponent />
    </>
  )
}
